export class MysteryCampaignModel {
  id: number;
  mystery_campaign_name: string;
  start_date: string;
  end_date: string;
  created_date: string;
  updated_date: string;
  status: any;
  statusString: string;
  show: boolean;
  startDate: any;
  endDate: any;
}


export class WhitelistUsersDateRangeModel {
  id: number;
  user_id: number;
  module_id: number;
  start_date: any;
  end_date: any;
  status: number;
  created_date: string;
  created_by: number;
  updated_date: string;
  updated_by: number; a
  module_campaign_id: number;
  ro_name: string;
  ro_code: any;
  user_name: any;
  channel_id: any;
  user_detail_name: any;
  contact_no: any;
  show: boolean;
  statusString: any;
}

export class MysteryQuestionBankModel {
  id: number;
  question: string;
  question_type: string;
  question_type_name: string;
  no_of_options: number;
  status: any;
  statusString: any;
  points: number;
  sub_question: any;
  sub_question_id: any;
  created_date: string;
  update_date: string;
  options: MysteryQuestionOptionModel[]
}

export class MysteryQuestionOptionModel {
  id: number;
  mystery_questionnaire_id: number;
  option_text: any;
  points: number;
  status: number;
  is_answer: boolean
}

export class MysteryTemplateModel {
  id: number;
  template_name: string;
  channel_id: number;
  geographical_id: number;
  created_date: string;
  update_date: string;
  created_by: string;
  start_date: string;
  end_date: string;
  status: any;
  region_id: number;
  mystery_campaign_id: number;
  mystery_campaign_name: string;
  instruction: string;
  channel_name: string;
  region_name: string;
  geography_name: string;
  statusString: any;
  show: boolean;
  endDate: any;
  startDate: any;
}

export class MysteryCampaignAssignedModel {
  outlet_id: number;
  outlet_name: string;
  outlet_code: number;
  channel_id: number;
  channel_name: string;
  region_id: number;
  region_name: string;
  mystery_campaign_name: string;
  outlet_status: string;
  mystery_shopper_user_name: string;
  mystery_shopper_user_id: number;
  mystery_shopper_mobile_number: string;
  status: number;
  end_date: any;
  mystery_campaign_id: number;
  showCheckBox: boolean;
  bulkChecked: boolean;
  reassign: boolean;
  start_date: any;
  assigned_id: number;
  campaign_end_date: any;
  startDate: any;
  endDate: any;
}

export class MysteryTemplateAssignedUsersModel {
  id: number;
  template_id: number;
  template_name: any;
  outlet_user_id: number;
  status: number;
  created_date: any;
  updated_date: any;
  ro_name: any;
  ro_code: any;
  user_name: any;
  channel_id: number;
  user_detail_name: any;
  contact_no: any;
  show: boolean;
  statusString: any;
}

